// extracted by mini-css-extract-plugin
module.exports = {"container":"Tags_container__1fOcz"};